import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm, blur } from 'redux-form';
import { disableReturn } from '../../../utils/library';
import RenderCommonDropdownField from '../../form-controls/RenderCommonDropdownField';
import BoxDropdown from '../../../components/form-controls/outlinedDropdown';
import { FORMNAME_BENEFICIARY_DETAILS, FORMNAME_IFSC_FINDER } from '../../../utils/constants';

import {
  getIFSCBranches,
  getIFSCStates,
  getIFSCCity,
  getIFSCCode
} from '../../../redux/actions/individual-user-flow/individual-user-flow-action';
import { verifyIfscCode } from '../../../redux/actions/common/common-action';
import './ifsc-finder.css';
import CommonButton from '../../common-button/CommonButton';

class IFSCFinder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankNames: [],
      stateNames: [],
      cityNames: [],
      branchNames: [],
      ifscCode: [],
      selectedBank: '',
      selectedState: '',
      selectedCity: '',
      selectedBranch: '',
      selectedIFSC: '',
      showBankNamesLoader: false,
      showStateNamesLoader: false,
      showCityNamesLoader: false
    };
  }
  async componentDidMount() {
    this.setState({ showBankNamesLoader: true });
    this.props.dispatch(change(FORMNAME_IFSC_FINDER, 'ifsc_bank_name', ''));
    let response = await this.props.getIFSCBranches();
    if (response && response.data && response.data.success && response.data.data) {
      let data = response.data.data;
      data.forEach((item) => {
        item['text'] = item.key;
      });
      await this.setState({ bankNames: data, showBankNamesLoader: false });
    }
  }
  onBankChange = async (obj) => {
    if (obj) {
      await this.setState({
        selectedBank: obj.bankId,
        selectedState: '',
        selectedCity: '',
        selectedBranch: '',
        showBankNamesLoader: true,
        selectedIFSC: ''
      });
      this.props.dispatch(change(FORMNAME_IFSC_FINDER, 'ifsc_state', ''));
      const { selectedBank } = this.state;
      let response_state = await this.props.getIFSCStates(selectedBank);
      if (
        response_state &&
        response_state.data &&
        response_state.data.success &&
        response_state.data.data
      ) {
        let states = response_state.data.data;
        states.map((item) => (item['text'] = item.key));
        this.props.dispatch(change(FORMNAME_IFSC_FINDER, 'ifsc_state', ''));
        await this.setState({
          showBankNamesLoader: false,
          stateNames: states,
          cityNames: [],
          ifscCode: [],
          branchNames: [],
          selectedState: '',
          selectedCity: '',
          selectedBranch: '',
          selectedIFSC: ''
        });
      }
    }
  };
  onStateChange = async (obj) => {
    if (obj) {
      await this.setState({
        selectedState: obj.value,
        selectedCity: '',
        selectedBranch: '',
        showStateNamesLoader: true,
        selectedIFSC: ''
      });
      const { selectedBank, selectedState } = this.state;
      let response = await this.props.getIFSCCity(selectedBank, selectedState);
      if (response && response.data && response.data.success && response.data.data) {
        let cities = response.data.data;
        cities.map((item) => (item['text'] = item.key));
        this.props.dispatch(change(FORMNAME_IFSC_FINDER, 'ifsc_city', ''));
        await this.setState({
          cityNames: cities,
          ifscCode: [],
          branchNames: [],
          selectedCity: '',
          selectedBranch: '',
          showStateNamesLoader: false,
          selectedIFSC: ''
        });
      }
    }
  };
  onCityChange = async (obj) => {
    if (obj) {
      await this.setState({
        selectedCity: obj.value,
        selectedBranch: '',
        showCityNamesLoader: true,
        selectedIFSC: ''
      });
      const { selectedBank, selectedCity, selectedState } = this.state;
      let response = await this.props.getIFSCCode(selectedBank, selectedState, selectedCity);
      if (response && response.data && response.data.success && response.data.data) {
        let codes = response.data.data,
          branches = [];
        codes.forEach((item) => {
          item['text'] = item.key;
          branches.push({
            text: item.value,
            value: item.value,
            IFSC: item.key,
            key: item.key
          });
        });
        this.props.dispatch(change(FORMNAME_IFSC_FINDER, 'ifsc_branch', ''));

        await this.setState({
          ifscCode: [],
          branchNames: branches,
          selectedBranch: '',
          selectedIFSC: '',
          showCityNamesLoader: false
        });
      }
    }
  };
  onBranchChange = async (obj) => {
    if (obj) {
      await this.setState({
        selectedBranch: obj.value,
        ifscCode: [{ text: obj.IFSC, value: obj.IFSC, key: obj.IFSC }],
        selectedIFSC: obj.IFSC
      });
    }
  };

  submitIFSCDetails = async () => {
    const { selectedIFSC } = this.state;
    this.props.dispatch(
      change(
        this.props.formName || FORMNAME_BENEFICIARY_DETAILS,
        'routing_code_value_1',
        selectedIFSC
      )
    );
    let requestObject = {
      routing_code_type_1: 'IFSC',
      routing_code_value_1: selectedIFSC,
      country_code: 'IN'
    };

    let response = await this.props.dispatch(verifyIfscCode(requestObject));
    if (response && response.institution_name) {
      this.props.dispatch(
        blur(
          this.props.formName || FORMNAME_BENEFICIARY_DETAILS,
          this.props.isBeneSchema ? 'beneficiary_bank_name' : 'bank_name',
          response.institution_name
        )
      );
    }
    this.props.closeModal(false);
  };
  render() {
    const { handleSubmit, form_values, isNewFlow } = this.props;
    const {
      bankNames,
      stateNames,
      cityNames,
      branchNames,
      ifscCode,
      selectedBank,
      selectedCity,
      selectedIFSC,
      selectedState,
      selectedBranch,
      showBankNamesLoader,
      showCityNamesLoader,
      showStateNamesLoader
    } = this.state;
    const Component = isNewFlow ? BoxDropdown : RenderCommonDropdownField;
    let extraProps = isNewFlow
      ? {
          width: '100%'
        }
      : {};
    let disableButton = !selectedBank || !selectedIFSC || !selectedCity || !selectedState;
    return (
      <form
        id={FORMNAME_IFSC_FINDER}
        className="form-ifsc"
        onSubmit={handleSubmit(this.submitIFSCDetails)}
        onKeyUp={disableReturn}
        onKeyPress={disableReturn}
      >
        <div className="ifsc-title">Search for IFSC</div>
        <div className="ifsc-input-holder">
          <Field
            bindToThisObject={
              form_values && form_values.ifsc_bank_name ? form_values.ifsc_bank_name : null
            }
            type="text"
            name={'ifsc_bank_name'}
            component={Component}
            placeholder={'Bank name'}
            className={`ifsc-input-dropdown`}
            staticValues={bankNames}
            showLoader={showBankNamesLoader}
            onDropdownChange={(obj) => this.onBankChange(obj)}
            {...extraProps}
            labelClassName={`ifsc-bank-label`}
          />
        </div>
        {selectedBank && !showBankNamesLoader && (
          <div className="ifsc-input-holder">
            <Field
              bindToThisObject={
                form_values && form_values.ifsc_state ? form_values.ifsc_state : null
              }
              type="text"
              name={'ifsc_state'}
              component={Component}
              placeholder={'State'}
              className={`ifsc-input-dropdown`}
              staticValues={stateNames}
              showLoader={showStateNamesLoader}
              onDropdownChange={(obj) => {
                this.onStateChange(obj);
              }}
              {...extraProps}
              labelClassName={`ifsc-state-label`}
            />
          </div>
        )}
        {selectedState && !showStateNamesLoader && (
          <div className="ifsc-input-holder">
            <Field
              bindToThisObject={form_values && form_values.ifsc_city ? form_values.ifsc_city : null}
              type="text"
              name={'ifsc_city'}
              component={Component}
              placeholder={'City'}
              className={`ifsc-input-dropdown`}
              staticValues={cityNames}
              showLoader={showCityNamesLoader}
              onDropdownChange={(obj) => this.onCityChange(obj)}
              {...extraProps}
              labelClassName={`ifsc-city-label`}
            />
          </div>
        )}
        {selectedCity && !showCityNamesLoader && (
          <div className="ifsc-input-holder">
            <Field
              bindToThisObject={
                form_values && form_values.ifsc_branch ? form_values.ifsc_branch : null
              }
              labelClassName={`ifsc-branch-label`}
              type="text"
              name={'ifsc_branch'}
              component={Component}
              placeholder={'Branch'}
              showLoader={showBankNamesLoader}
              className={`ifsc-input-dropdown`}
              staticValues={branchNames}
              onDropdownChange={(obj) => {
                this.onBranchChange(obj);
              }}
              {...extraProps}
            />
          </div>
        )}
        {selectedBranch && (
          <div className="ifsc-input-holder">
            <Field
              bindToThisObject={form_values && form_values.ifsc_code ? form_values.ifsc_code : null}
              type="text"
              name={'ifsc_code'}
              labelClassName="ifsc-label"
              component={Component}
              disabled={ifscCode && ifscCode.length === 1}
              placeholder={'IFSC'}
              className={`ifsc-input-dropdown`}
              staticValues={ifscCode}
              preselect_if_one_item={true}
              onDropdownChange={async (obj) => await this.setState({ selectedIFSC: obj.key })}
              {...extraProps}
            />
          </div>
        )}
        <div className="button-container">
          <CommonButton text="Continue" disabled={disableButton} />
        </div>
      </form>
    );
  }
}

IFSCFinder.propTypes = {
  dispatch: PropTypes.func,
  getIFSCBranches: PropTypes.func,
  getIFSCStates: PropTypes.func,
  getIFSCCity: PropTypes.func,
  getIFSCCode: PropTypes.func,
  closeModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  form_values: PropTypes.object,
  isNewFlow: PropTypes.bool,
  isBeneSchema: PropTypes.bool,
  formName: PropTypes.string
};

let createReduxForm = reduxForm({
  form: FORMNAME_IFSC_FINDER
});
const ReduxFormIFSCFINDER = createReduxForm(IFSCFinder);
const mapStateToProps = (state) => {
  let form_values = getFormValues(FORMNAME_IFSC_FINDER)(state);
  return { form_values };
};
export default connect(mapStateToProps, {
  getIFSCBranches,
  getIFSCStates,
  getIFSCCity,
  getIFSCCode
})(ReduxFormIFSCFINDER);
